import ApiJobSkill from 'types/api/JobSkill';
import { Option } from 'types/options';

import Model from 'models/Model';

export default class JobSkill implements Model {
    id: string;
    name: string;
    slug: string;

    constructor(data: ApiJobSkill) {
        this.id = data.id;
        this.name = data.name;
        this.slug = data.slug;
    }

    getOption = (): Option<JobSkill> => {
        return {
            value: this,
            label: this.name,
        };
    };
}
